import Swiper, { Pagination } from 'swiper';


function clientSlider() {

    const cltSlider = new Swiper(".our-client-slider", {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 40,
        loop: false,
        slidesPerGroup: 2,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            568: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            768: {
                slidesPerView: 2,
            },
        },
    });


}

export default clientSlider;
